export const CHANGE_EDITION_POLL_INTERVAL_SECS = 3;
export const CHANGE_EDITION_POLL_DURATION_MINS = 1;
